<app-authorized-guard
  [authorized]="!unauthorized"
  message="You are not authorized to generate an API key."
>
  <app-loading-guard [loading]="!types$">
    <form
      class="entity-form"
      *ngIf="types$ | async as types"
      (submit)="createEntity()"
    >
      <mat-form-field class="form-field">
        <mat-label>Type</mat-label>
        <mat-select [formControl]="form.controls.type">
          <mat-option *ngFor="let type of types" [value]="type.id">{{
            type.name
          }}</mat-option>
        </mat-select>
        <mat-error>
          <app-control-errors controlName="type">
            <ng-template appControlError="api" dynamicMessage></ng-template>
          </app-control-errors>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="form-field">
        <input
          matInput
          name="name"
          type="text"
          placeholder="Name"
          [formControl]="form.controls.name"
        />
        <mat-error>
          <app-control-errors controlName="name">
            <ng-template appControlError="api" dynamicMessage></ng-template>
          </app-control-errors>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="form-field">
        <input
          matInput
          [matDatepicker]="expires_at"
          placeholder="Expires"
          [formControl]="form.controls.expiresAt"
          [min]="minDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="expires_at"
        ></mat-datepicker-toggle>
        <mat-datepicker #expires_at></mat-datepicker>
      </mat-form-field>
      <div class="form-buttons">
        <button mat-raised-button color="primary" [disabled]="pending">
          Generate
        </button>
        <a mat-button routerLink="/organization/apikeys">Cancel</a>
      </div>
    </form>
  </app-loading-guard>
</app-authorized-guard>
